import { Controller } from '@hotwired/stimulus'

// Mirrors the current value of a range/number input into a text output,
// with an optional suffix (e.g. " m"), and fills a custom track.
export default class extends Controller {
  static targets = ['input', 'output', 'range']
  static values = { suffix: { type: String, default: '' } }

  connect () {
    this.render()
  }

  render () {
    if (this.hasInputTarget && this.hasOutputTarget) {
      this.outputTarget.textContent = `${this.inputTarget.value}${this.suffixValue}`
    }

    this.updateTrack()
  }

  updateTrack () {
    if (!this.hasRangeTarget || !this.hasInputTarget) return

    const min = parseFloat(this.inputTarget.min) || 0
    const max = parseFloat(this.inputTarget.max) || 100
    const value = parseFloat(this.inputTarget.value) || min
    const span = max - min
    const width = span === 0 ? 0 : ((value - min) / span) * 100

    this.rangeTarget.style.width = `${width}%`
  }
}
